export enum StatusReferenceType {
    Sales,
    Payment,
    Delivery,
    OrderPayment,
    Voucher
}